<template>
    <section class="section">
        <b-row>
            <b-col>
                <b-card title="Allarmi">
                    <b-row class="mt-4">
                        <b-col>
                            <label>Filtra per </label>
                            <b-form-select class="filter form-control" v-model="type" :options="options"></b-form-select>
                        </b-col>
                        <b-col>
                            <label>Data </label>
                            <input type="date" class="filter form-control" v-model="day"/>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col>
                            <table class="table">
                                <thead>
                                    <tr> 
                                        <th scope="col">
                                            Data
                                        </th>
                                        <th scope="col" v-if="isSuperAdmin">
                                            Cliente
                                        </th>
                                        <th scope="col">
                                            Tipo
                                        </th>
                                        <th scope="col">
                                            Risolto il
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in copyAlarms" :key="idx" variant="light" :class="idx%2 == 0 ? 'item' : 'item2'" class="mt-2">
                                        <td>
                                            {{ formatDate(item.created_on) }}
                                        </td>
                                        <td v-if="isSuperAdmin">
                                            {{ item.customer_code }}
                                        </td>
                                        <td>
                                            {{ alertsLabels[item.type] }}
                                        </td>
                                        <td>
                                            <div v-if="item.solved_on == null">
                                                <font-awesome-icon icon="circle" style="color: red"/>
                                            </div>
                                            <div v-if="item.solved_on != null">
                                                <font-awesome-icon icon="circle" style="color: green" />
                                                {{ formatDate(item.solved_on) }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </section>
</template>

<script>

import api from '@/services/api';
import moment from 'moment';
import Table from '../Charts/Table.vue';

export default {
  components: { Table },
    name: "Alarms",
    data() {
        return {
            alarms: [],
            copyAlarms: [],
            type: null, 
            day: null,
            options: [
                { value: null, text: "Selezionare un filtro" },
                { value: "BLACKBOX_NODATA", text: "Assenza dati blackbox" },
                { value: "MEASURES_NODATA", text: "Assenza dati importati" },
                { value: "EDISTRIB_EXPIRED_PW", text: "Password E-Distribuzione scaduta" },
                
            ], 
            alertsLabels: {
                BLACKBOX_NODATA: "Assenza dati blackbox",
                MEASURES_NODATA: "Assenza dati importati",
                EDISTRIB_EXPIRED_PW: "Password E-Distribuzione scaduta"
            },      
        }
    },
    created() {
        api().get('/customer/alarms').then( data => {
            this.alarms = data.data.data;
            this.copyAlarms = this.alarms;
        });
    },
    computed: {
        isSuperAdmin() {
            return this.$store.state.user && this.$store.state.user.level == 1
        },
    },
    watch: {
        type() {
            this.filters();
        },
        day() {
            this.filters();
        }
    },
    
    methods: {
        filters() {
            var item = this.alarms;
            this.copyAlarms = this.alarms.filter( item => {
                if(this.type && item.type != this.type) {
                    return false;
                }
                if(this.day && moment(item.created_on).isBefore(this.day)) {
                    return false;
                }
                return true; 
            });
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm");
        }
    }
}
</script>

<style>
    .filter {
        width: 200px;
        display: inline-block;
    }
    .item {
        background-color: #f2f2f2;
    }
    .item2 {
        background-color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Alarms.vue